var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-menu',{style:({ height: '100%', borderRight: 0 }),attrs:{"mode":"inline","theme":"light"},on:{"click":_vm.onSelect},model:{value:(_vm.selectedKeys),callback:function ($$v) {_vm.selectedKeys=$$v},expression:"selectedKeys"}},[_vm._l((_vm.siderMenu),function(item,key){return [_c('a-menu-item',{key:key},[_vm._v(" "+_vm._s(item.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }